import React from "react";

function formatNumber(n) {
  return new Intl.NumberFormat("pt-BR").format(n);
}

// Institucional, sem repetição. Cada livro recebe uma variação estável baseada em `seed`.
// Todas as frases usam o sales_count REAL vindo do backend, zero dado inventado.
const PHRASES = [
  "pessoas já foram impactadas por este conteúdo",
  "leitores já iniciaram essa jornada",
  "vidas já foram alcançadas por estas páginas",
  "pessoas já receberam esta mensagem em casa",
  "leitores já caminham com esta obra",
  "pessoas já adquiriram este livro",
];

function pickPhrase(seed) {
  if (!seed) return PHRASES[0];
  // DJB2-style hash, distribuição melhor que soma simples, mesmo com seeds parecidos.
  let acc = 5381;
  for (let i = 0; i < seed.length; i++) {
    acc = ((acc * 33) ^ seed.charCodeAt(i)) >>> 0;
  }
  return PHRASES[acc % PHRASES.length];
}

export default function SalesCounter({
  count,
  className = "",
  variant = "light",
  seed = "",
  showDailyNote = true,
}) {
  if (!count) return null;
  const tones = {
    light: { text: "text-[#6B7280]", note: "text-[#6B7280]/80" },
    dark: { text: "text-white/70", note: "text-white/55" },
  };
  const tone = tones[variant] || tones.light;
  const phrase = pickPhrase(seed);

  return (
    <div
      data-testid="sales-counter"
      data-sales-count={count}
      className={`flex flex-col gap-1.5 ${className}`}
    >
      <div className={`flex items-center gap-2.5 ${tone.text}`}>
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[#C5A059] opacity-60 animate-ping" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#C5A059]" />
        </span>
        <span className="text-xs md:text-[0.82rem] font-light tracking-[0.02em]">
          Mais de{" "}
          <span className="text-[#C5A059] font-serif-display text-[1.05rem] md:text-[1.1rem] not-italic">
            {formatNumber(count)}
          </span>{" "}
          {phrase}
        </span>
      </div>
      {showDailyNote && (
        <p
          data-testid="sales-counter-daily-note"
          className={`text-[0.68rem] md:text-[0.7rem] ${tone.note} tracking-[0.02em] font-light pl-[1.05rem] leading-relaxed`}
        >
          Novas pessoas estão sendo impactadas todos os dias.
        </p>
      )}
    </div>
  );
}
